import React, { useState } from "react";
import MasterPanel from "./MasterPanel";
import Breadcrumb from "../../components/layout/Breadcrumb";
import EmployeeWelcomeMail from "./EmployeeWelcomeMail";
import PreOnboardingMailCC from "./PreOnboardingMailCC";
import UserInviteLink from "./UserInviteLink";
import Approval from "./Approval";
import EmployeeIdMatrix from "./EmployeeIdMatrix";
import SupportConfig from "./SupportConfig";
import AssignmentCategory from "./AssignmentCategory";
import { useSelector } from "react-redux";
import EmpRequiredDocs from "./EmpRequiredDocs";

export default function Settings() {
  const objectData = useSelector(state => state.dropdownList.dropdownList);
  const [activeSetting, setActiveSetting] = useState(null);

  const panelNames = [
    "Pre Onboarding",
    "Support",
  ];

  const renderActivePart = () => {
    if (!activeSetting) {
      return (
        < >
        </>
      )
    }
    switch (activeSetting.heading) {
      case 'EMPLOYEE_WELCOME_MAIL': return <EmployeeWelcomeMail configType={activeSetting.heading} configName={objectData?.EMPLOYEE_WELCOME_MAIL} />
      case 'PREONBOARDING_MAIL': return <PreOnboardingMailCC configType={activeSetting.heading} configName={objectData?.PREONBOARDING_MAIL} />
      case 'REQUIRED_DOCUMENTS': return <EmpRequiredDocs configType={activeSetting.heading} configName={objectData?.REQUIRED_DOCUMENTS}/>
      case 'USER_INVITE_LINK': return <UserInviteLink configType={activeSetting.heading} configName={objectData?.USER_INVITE_LINK} />
      case 'APPROVAL_MAIL': return <Approval configType={activeSetting.heading} configName={objectData?.APPROVAL_MAIL} />
      case 'EMPLOYEE_ID_MATRIX': return <EmployeeIdMatrix configType={activeSetting.heading} configName={objectData?.EMPLOYEE_ID_MATRIX} />
      case 'SUPPORT CONFIG': return <SupportConfig configType={activeSetting.heading} />
      case 'ASSIGNMENT FOR CATEGORY': return <AssignmentCategory configType={activeSetting.heading} />
      default: return null;
    }
  };

  return (

    <div className="container-fluid">
      <Breadcrumb />
      <div className="row mt-3">
        {/* navigation */}
        <div className="col-lg-4 col-md-5 overflow-y-auto mt-md-0 mt-1">
          {panelNames.map((name) => (
            <div key={name} className="mb-0">
              <MasterPanel panelName={name}
                onItemSelect={(item) => setActiveSetting(item)}
                activeItemHeading={activeSetting?.heading}
              />
            </div>
          ))}
        </div>

        {/* content */}
        <div className="col-lg-8 col-md-7 border-start mt-md-0 mt-3">
          <div className={activeSetting ? "p-2 p-md-4 bg-white shadow-sm rounded" : ""} style={{ minHeight: '400px' }}>
            {renderActivePart()}
          </div>
        </div>
      </div>
    </div>
  );
}